export default "__VITE_ASSET__BMC4oa_f__"